export default __webpack_public_path__ + "static/logo-aac10eb4419724437946d5b76ff5533b.png";